/**
 * @file index.tsx
 *
 * @fileoverview Renders a component.
 */
import React, { useContext } from 'react';
import { Job } from '~/jobiqo/types/types';
import { FormattedMessage } from 'react-intl';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import {
  jobCanApplyTo,
  jobIsQuickApply,
} from '~/jobiqo/components/Job/utils/job_application';
import { getJobApplicationSystemAvailable } from '~/jobiqo/components/JobApplication/utils';
import LightningIcon from '~/vcl/icons/Lightning';
import { HideMobile } from '~/vcl/atoms/06-layout/02-visibility/02-hide-mobile';
import { Button } from '~/vcl/atoms/01-forms/01-button';
import { BriefcaseIcon } from '~/vcl/icons/Briefcase';

interface JobApplyButtonProps {
  /**
   * The job to render apply for.
   */
  job: Job;
  /**
   * when job application gets clicked.
   */
  onApply: () => void;
  /**
   * If the application is restricted. If true, the submit button should be disabled.
   */
  applicationRestricted?: boolean;
}
export const JobApplyButton = ({
  job,
  onApply,
  applicationRestricted = false,
}: JobApplyButtonProps) => {
  if (!getJobApplicationSystemAvailable(job)) {
    return null;
  }

  const userContext: UserContextInterface = useContext(UserContext);

  if (userContext.user && !userContext.user.isEligibleForJobApply) {
    return null;
  }

  return jobCanApplyTo(job) ? (
    <HideMobile>
      <a target="_blank" rel="”nofollow”">
        <Button
          title="Apply"
          buttonStyle="primary"
          onClick={onApply}
          data-test-id="job-apply-submit-button"
          disabled={applicationRestricted}
        >
          {jobIsQuickApply(job) ? (
            <>
              <LightningIcon />
              <span>
                <FormattedMessage
                  id="quick_apply"
                  defaultMessage="Quick Apply"
                />
              </span>
            </>
          ) : (
            <>
              <BriefcaseIcon />
              <span>
                <FormattedMessage id="apply" defaultMessage="Apply" />
              </span>
            </>
          )}
        </Button>
      </a>
    </HideMobile>
  ) : null;
};
export default JobApplyButton;
